import { Tab } from "@headlessui/react";
import React, { useEffect, useMemo, useRef, useState } from "react";
import TabsMobile from "../__template/TabsMobileComponent";
import new1 from "../../assets/images/icon_mutation/new1.svg";
import new2 from "../../assets/images/icon_mutation/new2.svg";
import old1 from "../../assets/images/icon_mutation/old1.svg";
import old2 from "../../assets/images/icon_mutation/old2.svg";
import { formatCurrency } from "../../config/global";
import { useDispatch } from "react-redux";
import { useAppDispatch, useAppSelector } from "../../core/feature/hooks";
import { setLoading } from "../../core/feature/config/configSlice";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import "react-spring-bottom-sheet/dist/style.css";
import User from "../../core/models/user";
import { getMutation, getMutationOlder } from "../../core/service/api_mutation";
import { LazyLoadImage } from "react-lazy-load-image-component";
import {
  getdetailOlderTransaction,
  getdetailTransaction,
  getOlderTransactions,
  getTransactions,
} from "../../core/service/api_transaction";
import { useTranslation } from "react-i18next";
const ComponentTransactionDetailHistory = () => {
  const user: User = useAppSelector((state) => state.user.user);
  const [transaction, setTransaction] = useState<any>([]);
  const [transactionOlder, setTransactionOlder] = useState<any>([]);
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);
  const [activeTab, setActiveTab] = useState(0);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  let location: any = useLocation();
  const { t } = useTranslation();

  const month = String(Number(moment().format("MM")));
  // this.month = String(Number(moment().format("MM")) - 1)

  const year = new Date().getFullYear().toString();

  const monthYear = year + "-" + month + "-01";
  const minDate = moment().subtract(89, "days").format("YYYY-MM-DD");
  const maxDate = year + "-" + month + "-01";
  const minDate2 = "2020-01-01";
  const maxDate2 = moment().subtract(90, "days").format("YYYY-MM-DD");
  let [categories] = useState({
    "3 Bulan Terakhir": [],
    "Diatas 3 Bulan": [],
  });
  function classNames(...classes: string[]) {
    return classes.filter(Boolean).join(" ");
  }

  const getTransactionDetail = async (
    month: number,
    year: number,
    transactionName: String
  ) => {
    dispatch(setLoading(true));
    getdetailTransaction(month, year, transactionName)
      .then((res: any) => {
        dispatch(setLoading(false));
        setTransaction(res.data.content);
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
        navigate("/login", { replace: true });
      });
  };

  const getTransactionDetailOlder = async (
    month: number,
    year: number,
    transactionName: String
  ) => {
    dispatch(setLoading(true));
    getdetailOlderTransaction(month, year, transactionName)
      .then((res: any) => {
        dispatch(setLoading(false));
        setTransaction(res.data.content);
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
        navigate("/login", { replace: true });
      });
  };

  // const addMoreMutationsOlder = async () => {
  //   setPage(page + 1);

  //   dispatch(setLoading(true));
  //   getMutationOlder(fromDateOlder, toDateOlder, page + 1, size)
  //     .then((res) => {
  //       dispatch(setLoading(false));
  //       setMutationsOlder(mutationsOlder.concat(res.data.content));
  //       console.log(res.data);
  //     })
  //     .catch((err) => {
  //       dispatch(setLoading(false));
  //       navigate("/login", { replace: true });
  //     });
  // };

  // const currentSizeMutations = useMemo(() => {
  //   const a = mutations.length;
  //   const b = a / (page + 1);
  //   console.log("b", a, b);

  //   return b;
  // }, [mutations]);

  // const currentSizeMutationsOlder = useMemo(() => {
  //   const a = mutationsOlder.length;
  //   const b = a / (page + 1);
  //   console.log("b", a, b);

  //   return b;
  // }, [mutationsOlder]);

  useEffect(() => {
    if (location.state.isOlder == false) {
      getTransactionDetail(
        location.state.month,
        location.state.year,
        location.state.transactionName
      );
    } else {
      getTransactionDetailOlder(
        location.state.month,
        location.state.year,
        location.state.transactionName
      );
    }
  }, []);
  return (
    <div className="min-h-screen h-full  bg-psp-primary">
      <div className="bg-white px-8 pt-8 pb-3 sticky top-0 z-50">
        <TabsMobile
          name={`${t("TRANSACTION-DETAIL.title")}`}
          backUrl={"transaction-history"}
        ></TabsMobile>
      </div>
      <div className="p-4 top-to-bottom">
        {transaction.length < 1 ? (
          <div className="flex justify-center">
            <span className="font-normal text-xs text-center">
              {t("OTHER.dataNotFound")}
            </span>
          </div>
        ) : (
          <div className="flex flex-col gap-2.5 ">
            {transaction.map((res: any) =>
              res.credit == "0" ? (
                <div className="bg-white rounded-xl shadow-md font-montserrat border-l-4 border-solid border-l-rose-500">
                  <div className="flex flex-row px-3 py-3 gap-2 items-center">
                    <div className="flex flex-col grow gap-1">
                      <span className="font-montserrat font-light text-xs text-psp-nav">
                        {moment(res.createDate).format("LLL")}
                      </span>
                      <span className="font-montserrat font-semibold text-xs">
                        {res.transactionName}
                      </span>
                      <span className="font-montserrat font-normal text-xs">
                        {res.callerName}
                      </span>
                      {res.note != "" && (
                        <span className="font-montserrat font-normal text-xs">
                          {res.note}
                        </span>
                      )}
                      <span className="font-montserrat font-semibold text-xs">
                        {formatCurrency(res.debit)}
                      </span>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="bg-white rounded-xl shadow-md font-montserrat border-l-4 border-solid border-l-green-500">
                  <div className="flex flex-row px-3 py-3 gap-2 items-center">
                    <div className="flex flex-col grow gap-1">
                      <span className="font-montserrat font-light text-xs">
                        {moment(res.createDate).format("LLL")}
                      </span>
                      <span className="font-montserrat font-light text-xs">
                        {res.callerName}
                      </span>
                      {res.note != "" && (
                        <span className="font-montserrat font-normal text-xs">
                          {res.note}
                        </span>
                      )}
                      <span className="font-montserrat font-semibold text-sm">
                        {formatCurrency(res.credit)}
                      </span>
                    </div>
                  </div>
                </div>
              )
            )}
          </div>
        )}

        {/* {currentSizeMutations < 10 ? (
              ""
            ) : (
              <div className="flex w-full mt-2">
                <button
                  onClick={addMoreMutations}
                  className="w-full transparent px-2 py-2.5 rounded-lg text-psp-hover underline text-center items-center font-bold text-xs active:text-psp-active "
                >
                                    {t("OTHER.showMore")}

                </button>
              </div>
            )} */}
      </div>
    </div>
  );
};

export default ComponentTransactionDetailHistory;
